const { calculateVoiceQuote } = require('./voicePricing');
const defaultVoiceOptions = { binaural: false, video: false, rate: 1.5, tip: 0, withholding: true };
function defaultAvailability() {
  const date = new Date();
  date.setDate(date.getDate() + 7);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
function validDate(value) {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
}
function readVoiceQuoteSearch(search) {
  const params = new URLSearchParams(search);
  const options = { ...defaultVoiceOptions, availability: defaultAvailability() };
  for (const key of ['rate', 'tip']) {
    if (params.has(key)) {
      try { options[key] = calculateVoiceQuote('', { [key]: params.get(key) })[key]; } catch { /* Invalid links use the default for this field. */ }
    }
  }
  for (const key of ['binaural', 'video', 'withholding']) {
    if (['0', '1'].includes(params.get(key))) options[key] = params.get(key) === '1';
  }
  if (validDate(params.get('availability'))) options.availability = params.get('availability');
  return options;
}
function voiceQuoteSearch(options) {
  const quote = calculateVoiceQuote('', options);
  if (!validDate(options.availability)) throw Error('納品可能日を入力してください。');
  // An explicit allowlist keeps applicant details out of shared links.
  return new URLSearchParams({ rate: String(quote.rate), binaural: options.binaural ? '1' : '0', video: options.video ? '1' : '0', tip: String(quote.tip), withholding: options.withholding === false ? '0' : '1', availability: options.availability }).toString();
}
module.exports = { defaultVoiceOptions, defaultAvailability, validDate, readVoiceQuoteSearch, voiceQuoteSearch };
